export default __webpack_public_path__ + "static/media/straightLine.8ac1556f.svg";